import { useTranslation } from 'react-i18next'
import NotificationBar from '~/components/NotificationBar'

interface IProps {
  checked: boolean
  setChecked: (value: boolean) => void
}

const PriceImpactConfirm: React.FC<IProps> = ({
  checked,
  setChecked,
}: IProps) => {
  const { t } = useTranslation()

  return (
    <NotificationBar
      style={{ marginTop: 16 }}
      level="risk"
      text={t('spotswap_swap_price_impact_too_high_confirm')}
      showIcon={false}
      showLink={false}
      showClose={false}
      showCheckBox={true}
      checked={checked}
      setChecked={setChecked}
    />
  )
}

export default PriceImpactConfirm
